import type { WhiteLabel } from '@skytech/types/white-label'

type Status = 'selected' | 'mandatory' | 'expired'

export const borderStyleByWhiteLabel: Partial<Record<WhiteLabel, Partial<Record<Status, string>>>> =
  {
    skytech: {
      selected:
        'border-zinc-500 hover:border-zinc-400 active:border-zinc-400 focus:border-zinc-400',
      mandatory:
        'border-yellow-500 hover:border-yellow-500/50 active:border-yellow-500/50 focus:border-yellow-500/50',
      expired: 'border-red hover:border-red/50 active:border-red/50 focus:border-red/50',
    },
    ice: {
      selected:
        'border-zinc-500 hover:border-zinc-400 active:border-zinc-400 focus:border-zinc-400',
      mandatory:
        'border-[#ffb901] hover:border-[#ffb901]/50 active:border-[#ffb901]/50 focus:border-[#ffb901]/50',
      expired: 'border-red hover:border-red/50 active:border-red/50 focus:border-red/50',
    },
    arp: {
      selected: 'border-arp hover:border-arp/50 active:border-arp/50 focus:border-arp/50',
      mandatory:
        'border-yellow-500 hover:border-yellow-500/50 active:border-yellow-500/50 focus:border-yellow-500/50',
      expired: 'border-red hover:border-red/50 active:border-red/50 focus:border-red/50',
    },
    mobit: {
      selected: 'border-mobit hover:border-mobit/50 active:border-mobit/50 focus:border-mobit/50',
      mandatory:
        'border-yellow-500 hover:border-yellow-500/50 active:border-yellow-500/50 focus:border-yellow-500/50',
      expired: 'border-red hover:border-red/50 active:border-red/50 focus:border-red/50',
    },
    bechtle: {
      selected:
        'border-bechtle hover:border-bechtle/50 active:border-bechtle/50 focus:border-bechtle/50',
      mandatory:
        'border-yellow-500 hover:border-yellow-500/50 active:border-yellow-500/50 focus:border-yellow-500/50',
      expired: 'border-red hover:border-red/50 active:border-red/50 focus:border-red/50',
    },
    telia: {
      selected: 'border-telia hover:border-telia/50 active:border-telia/50 focus:border-telia/50',
      mandatory:
        'border-yellow-500 hover:border-yellow-500/50 active:border-yellow-500/50 focus:border-yellow-500/50',
      expired:
        'border-telia-red hover:border-telia-red/50 active:border-telia-red/50 focus:border-telia-red/50',
    },
    elkjop: {
      selected:
        'border-elkjop hover:border-elkjop/50 active:border-elkjop/50 focus:border-elkjop/50',
      mandatory:
        'border-yellow-500 hover:border-yellow-500/50 active:border-yellow-500/50 focus:border-yellow-500/50',
      expired:
        'border-red-600 hover:border-red-600/50 active:border-red-600/50 focus:border-red-600/50',
    },
    komplett: {
      selected:
        'border-komplett hover:border-komplett/50 active:border-komplett/50 focus:border-komplett/50',
      mandatory:
        'border-komplett-darkYellow hover:border-komplett-darkYellow/50 active:border-komplett-darkYellow/50 focus:border-komplett-darkYellow/50',
      expired:
        'border-red-600 hover:border-red-600/50 active:border-red-600/50 focus:border-red-600/50',
    },
    threeStepIT: {
      selected:
        'border-threeStepIT-emerald hover:border-threeStepIT-seaMistPrimary-hover active:border-threeStepIT-seaMistPrimary-active focus:border-threeStepIT-seaMistPrimary-active',
      mandatory:
        'border-threeStepIT-warning hover:border-threeStepIT-warning/50 active:border-threeStepIT-warning/50 focus:border-threeStepIT-warning/50',
      expired:
        'border-threeStepIT-failure hover:border-threeStepIT-failure-hover active:border-threeStepIT-failure-active focus:border-threeStepIT-failure-active',
    },
  }

export const fillExpiredColorByWhiteLabel: Partial<Record<WhiteLabel, string>> = {
  telia: 'fill-telia-red',
  elkjop: 'fill-red-600',
  komplett: 'fill-red-600',
  threeStepIT: 'fill-threeStepIT-failure',
  skytech: 'red',
}

export const cardLoaderCircleStyleByWhiteLabel: Partial<Record<WhiteLabel, string>> = {
  skytech: '[&>div::after]:bg-gray-500',
  control: '[&>div::after]:bg-gray-500',
  tcm: '[&>div::after]:bg-gray-500',
  threeStepIT: '[&>div::after]:bg-threeStepIT',
  telia: '[&>div::after]:bg-telia',
}

type StatusInStock = 'success' | 'warning' | 'error'
// ProductGroup / inStock element styles
export const bgColorClassByWhiteLabel: Partial<Record<WhiteLabel, Record<StatusInStock, string>>> =
  {
    skytech: {
      success: 'bg-green-badge',
      warning: 'bg-[#f1c40f]',
      error: 'bg-red',
    },
    threeStepIT: {
      success: 'bg-threeStepIT-success',
      warning: 'bg-threeStepIT-warning',
      error: 'bg-threeStepIT-failure',
    },
  }
